/* Campo nome (canale, categoria, ruolo) con il pulsante «𝓐𝓪 Font»: gli stili Unicode «Instagram» (𝓒𝓸𝓻𝓼𝓲𝓿𝓸, ᴍᴀɪᴜꜱᴄᴏʟᴇᴛᴛᴏ, Ⓒⓔⓡⓒⓗⓘ…). */
import { useState } from "react";
import { Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { FANCY_STYLES, detectStyle, toFancy, toPlain } from "@/lib/fancyText";

// Le emoji/simboli all'inizio del nome (es. «🎫・» o «📢┃») restano come sono: si trasforma solo il testo.
const split = (name) => {
  const m = String(name || "").match(/^([^\p{L}\p{N}]*)(.*)$/u);
  return [m?.[1] ?? "", m?.[2] ?? ""];
};

export function FancyNameInput({ value, onChange, className = "", testId, disabled, placeholder }) {
  const [open, setOpen] = useState(false);
  const [prefix, text] = split(value);
  const plain = toPlain(text);
  const current = detectStyle(text);
  const currentName = FANCY_STYLES.find((st) => st.key === current)?.name;
  const apply = (key) => { onChange(prefix + (key ? toFancy(plain, key) : plain)); setOpen(false); };
  return (
    <div className="flex gap-1.5">
      <Input value={value} disabled={disabled} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} data-testid={testId} className={`min-w-0 flex-1 ${className}`} />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" disabled={disabled || !plain.trim()} title="Cambia il font del nome (stili come su Instagram)"
            className="flex shrink-0 items-center gap-1 rounded-md border border-[#232838] bg-[#131620] px-2.5 text-xs font-bold text-[#c7cbfb] hover:border-[#5865F2]/60 hover:text-white disabled:opacity-40 data-[state=open]:border-[#5865F2]">
            <span className="text-sm">𝓐𝓪</span>Font
          </button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-[320px] border-[#2e3450] bg-[#1b1f2e] p-1.5 text-[#DBDEE1]">
          <p className="px-2 pb-1.5 pt-1 text-[11px] text-[#949BA4]">Scegli uno stile per «{plain}». Emoji e simboli all'inizio restano uguali.</p>
          {currentName && <p className="mx-2 mb-1.5 rounded-md bg-[#5865F2]/15 px-2 py-1 text-[11px] text-[#c7cbfb]">Stile attuale: <b className="text-white">{currentName}</b></p>}
          <div className="max-h-80 overflow-y-auto">
            <button type="button" onClick={() => apply(null)} className="flex w-full items-center justify-between rounded-md px-2.5 py-1.5 text-left hover:bg-white/5">
              <span><span className="block text-[15px] text-white">{plain}</span><span className="text-[10px] text-[#6b7185]">Normale</span></span>
              {text === plain && <Check className="h-4 w-4 text-[#8ea0ff]" />}
            </button>
            {FANCY_STYLES.map((st) => {
              const out = toFancy(plain, st.key);
              return (
                <button key={st.key} type="button" onClick={() => apply(st.key)} className="flex w-full items-center justify-between rounded-md px-2.5 py-1.5 text-left hover:bg-white/5">
                  <span className="min-w-0"><span className="block truncate text-[15px] text-white">{prefix}{out}</span><span className="text-[10px] text-[#6b7185]">{st.name}</span></span>
                  {(st.key === current || text === out) && <Check className="h-4 w-4 shrink-0 text-[#8ea0ff]" />}
                </button>
              );
            })}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
